import * as types from './types'
import storage from '@/plugins/storage'
export default () => ({
  linkDefault: {
    groupCategory: {
      id: null,
      name: null
    },
    results: []
  },
  linksDefault: {
    _embedded: {
      data: {
        GEN3NA: {
          _embedded: {
            data: {
              dataSource: {
                name: 'OPUS IVS'
              },
              results: []
            }
          }
        }
      }
    }
  },
  newResultType: {
    firm: 1,
    isInactive: false,
    sort: 0,
    year: null,
    vehicleMake: null,
    vehicleMakeName: '',
    driveType: null,
    driveTypeName: '',
    testdriveResultType: null,
    testdriveResultTypeName: '',
    testdriveResultCode: ''
  },
  newadasmatrix: {
    id: null,
    adasChecklistMatrix: null,
    matrixItem: null,
    isInactive: false,
    isRemove: false,
    sort: 0,
    items: [],
    notice: '',
    hints: '',
    keywords: ''
  },
  newadasmakematrix: {
    id: null,
    adasChecklistMatrixVehicle: null,
    adasChecklistMatrix: null,
    vehicleMake: null,
    vehicleModel: null,
    yearStart: null,
    yearEnd: null,
    system: null,
    location: null,
    isRR: false,
    isRI: false,
    systemType: null,
    locationType: null,
    calibrationType: null,
    url: null,
    isInactive: false,
    sort: null,
    source: null,
    locations: [],
    systems: [],
    static: [],
    dynamic: [],
    triggerNotice: null,
    triggerNoticeText: null,
    cccLocationKeywords: [],
    cccLineKeywords: [],
    cccSubletKeywords: [],
    isAddlOperationRequired: false,
    addlOperations: []
  },
  newadasmatrixinfolookup: {
    id: null,
    adasChecklistMatrixInfoLookup: null,
    adasChecklistMatrix: null,
    vehicleMake: null,
    yearStart: null,
    yearEnd: null,
    keywords: null,
    lookupType: null,
    url: null,
    isInactive: false,
    sort: null,
    source: null,
    isReportAdd: false,
    description: null
  },
  newadaslink: {
    adasChecklistMatrix: null,
    adasChecklistMatrixVehicle: null,
    source: null,
    lookupType: null,
    year: null,
    vehicleMake: null,
    model: null,
    terms: null
  },
  newNoScrubItem: {
    adasNoScrubList: null,
    vehicleMake: null,
    vehicleModel: null,
    yearStart: null,
    yearEnd: null,
    isInactive: false,
    reason: null
  },
  recommendations: [],
  recommendation: null,
  criteriaChanged: false,
  step: 1,
  visitedStep: 1,
  translations: [],
  testdriveResultTypes: [],
  testdriveResultType: null,
  exclusions: [],
  adasmatrix: null,
  adasmatrices: JSON.parse(storage.session.getItem(types.SESSION_ADAS_MATRIX)) || [],
  decodedVin: [],
  decodedAltVin: [],
  adasmakematrices: [],
  adasmakematrix: null,
  adasmatrixinfolookups: [],
  adasmatrixinfolookup: null,
  adasLink: null,
  adasLinks: [],
  adasMakeMatrixCategories: [],
  //adasMakeMatrixSubCategories: null,
  makeExceptions: [],
  matrixKeywordsTriggers: [],
  matrixAdasInfo: [],
  makeExceptionLookups: [],
  noScrubList: [],
  noScrubItem: null,
  systemCalibrations: [],
  calibrationPricing: [],
  newBlueprintInfoLookup: {
    firm: null,
    blueprintInfoLookup: null,
    vehicleMake: null,
    yearStart: null,
    yearEnd: null,
    title: null,
    description: null,
    url: null,
    isInactive: false,
    sort: null
  },
  blueprintInfoLookups: [],
  blueprintInfoLookup: null,
  decodeScrubRules: [],
  decodeScrubRule: null,
  eulas: []
})



// WEBPACK FOOTER //
// ./src/store/modules/admin/configuration/state.js